package navigation.home.invoice.allinvoice

import cafe.adriel.voyager.core.model.StateScreenModel
import cafe.adriel.voyager.core.model.screenModelScope
import com.essntl.core.quickbooks.domain.QuickbooksClient
import com.essntl.core.utils.utils.loadingmanager.LoadingManager
import com.essntl.features.invoice.domain.repository.InvoiceRepository
import com.essntl.features.invoice.ui.allinvoice.InvoiceEvent
import com.essntl.features.invoice.ui.allinvoice.InvoiceState
import com.essntl.features.invoice.ui.allinvoice.AllInvoiceViewModel

class AllInvoiceScreenModel(
    invoiceRepository: InvoiceRepository,
    quickbooksClient: QuickbooksClient,
    loadingManager: LoadingManager,
) : StateScreenModel<InvoiceState>(InvoiceState()) {

    private val vm = AllInvoiceViewModel(
        invoiceRepository = invoiceRepository,
        quickbooksClient = quickbooksClient,
        loadingManager = loadingManager,
        scope = screenModelScope,
        state = mutableState,
    )

    fun onEvent(event: InvoiceEvent) {
        vm.onEvent(event)
    }
}